@if(results){
    @if(poll.itemType === 'closedQuestionResultItem') {
        <p class="fw-bold text-center text-secondary fst-italic pt-2 fs-6">{{ 'trend_graph_legend_percentage' | translate}} (%)</p>
        <recurring-closed-poll-result-trends-chart [dates]="dates"
                                                   [series]="series[0]"
                                                   [chartId]="'trends-'+poll.id"></recurring-closed-poll-result-trends-chart>
    } @else {
        <recurring-poll-result-trends-line-chart [dates]="dates"
                                                 [series]="series"
                                                 [chartId]="'trends-' + poll.id"></recurring-poll-result-trends-line-chart>
    }

    @switch (poll.itemType) {
        @case ('fiveStarsQuestionResultItem'){
            <div class="px-3 pt-1 fs-6 fst-italic text-secondary text-center">
                <p>{{ 'poll_results.trends_desc1' | translate }} <b>{{$safeNavigationMigration(results?.recurrenceType) | translate}} ({{results?.dates.length}} {{ 'poll_results.trends_desc2' | translate }})</b>.</p>
                <p>{{ 'poll_results.trends_desc' | translate }}</p>
                <p>{{ 'poll_results.trends_desc3' | translate }}</p>
            </div>
        }
        @case ('agreeDisagreeQuestionResultItem'){
            <div class="px-3 pt-1 fs-6 fst-italic text-secondary text-center">
                <p>{{ 'poll_results.trends_desc1' | translate }} <b>{{$safeNavigationMigration(results?.recurrenceType) | translate}} ({{results?.dates.length}} {{ 'poll_results.trends_desc2' | translate }})</b>.</p>
                <p class="">{{'poll_results.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'poll_results.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b> (5). {{ 'poll_results.trends_desc3' | translate }}</p>
            </div>
        }
        @case ('scaleQuestionResultItem'){
            <div class="px-3 pt-1 fs-6 fst-italic text-secondary text-center">
                <p>{{ 'poll_results.trends_desc1' | translate }} <b>{{$safeNavigationMigration(results?.recurrenceType) | translate}} ({{results?.dates.length}} {{ 'poll_results.trends_desc2' | translate }})</b>.</p>
                <p class="">{{'poll_results.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'poll_results.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b> (5). {{ 'poll_results.trends_desc3' | translate }}</p>
            </div>
        }
    }
    @if(nullSeries > 0){
        <p class="px-3 fs-6 fst-italic text-secondary text-center">{{'poll_results.trends_desc.no_data' | translate: {nullSeries: nullSeries} }}</p>   
    }
}